module.exports = __webpack_public_path__ + "img/10ne.3ea92c23.svg";